import { localisedValue } from "../../../utils"

export const workflowTaskTypesTransformer = (data = []) => {
  return data.map(item => {
    const { children } = item
    return {
      title: localisedValue({ object: item, key: "taskTitle" }),
      value: item?.id.toString(),
      key: item?.id.toString(),
      ...(children?.length && { children: workflowTaskTypesTransformer(children) }),
    }
  })
}
